import script from "./GallerySection.vue?vue&type=script&setup=true&lang=js"
export * from "./GallerySection.vue?vue&type=script&setup=true&lang=js"

import "./GallerySection.vue?vue&type=style&index=0&id=55319a79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55319a79"]])

export default __exports__